/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var EMPTY_ARRAY = [];

var _default = function _default(props) {
  var computedLockedStartRows = (0, _react.useMemo)(function () {
    return props.lockedRows ? props.lockedRows.filter(function (r) {
      return r.position !== 'end';
    }) : EMPTY_ARRAY;
  }, [props.lockedRows]);
  var computedLockedEndRows = (0, _react.useMemo)(function () {
    return props.lockedRows ? props.lockedRows.filter(function (r) {
      return r.position === 'end';
    }) : EMPTY_ARRAY;
  }, [props.lockedRows]);
  var result = {
    computedLockedRows: props.lockedRows || EMPTY_ARRAY,
    computedLockedStartRows: computedLockedStartRows,
    computedLockedEndRows: computedLockedEndRows
  };
  return result;
};

exports.default = _default;